'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
function BasketOrder(containerID) {
    this.containerID = containerID;
    this.$container = null;

    this.init();
}

BasketOrder.prototype = $.extend({}, {
    construtor: 'BasketOrder',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;
      
        _this.$container.on('click', '#thepay-method-box .thepay-methods-radio-method', function () {
          $('#thepay-method-box').find('.thepay-method-selected').removeClass('thepay-method-selected');
          $(this).closest('.thepay-methods-radio-method').addClass('thepay-method-selected');
          $(this).closest('.thepay-methods-radio-method').find('input').prop('checked', true);
        });

        /*
        _this.$container.off('click', '.remove-basket-item');
        _this.$container.on('click', '.remove-basket-item', function removeBasketClickClb() {
            alert('test');
            services.get('window').redirectTo(services.get('configurations').param('BasketURL'));
            return false;   
        });
        */

        return _this;
    },

    //**************************************************************************    

    init: function init() {
        var _this = this;

        _this.$container = $('#' + _this.containerID);      
        _this.registerCallbacks();

        return _this;
    }
});
